// Remembered member on this phone, per gym. localStorage can be unavailable
// (private mode, blocked storage) - every access is guarded so the page still
// works, it just asks for the phone number again.
const key = companyId => `dk_member:${companyId}`

export function getRememberedToken(companyId) {
  try { return companyId ? localStorage.getItem(key(companyId)) : null } catch (e) { return null }
}

export function rememberToken(companyId, token) {
  try { if (companyId && token) localStorage.setItem(key(companyId), token) } catch (e) { /* ignore */ }
}

export function forgetToken(companyId) {
  try { if (companyId) localStorage.removeItem(key(companyId)) } catch (e) { /* ignore */ }
}

export function durationLabel(value, unit) {
  const n = parseInt(value, 10) || 1
  return `${n} ${unit}${n === 1 ? '' : 's'}`
}

export function money(v) {
  return 'KES ' + Number(v || 0).toLocaleString('en-KE', { maximumFractionDigits: 0 })
}
